import { makeAutoObservable } from 'mobx';
import Subjects from '../../models/subjects';
import ITask from "../../models/task";
import { TaskService } from '../../services/task-service';
import TaskCloneStore from './task-clone';

export default class TaskItemStore {

    data: ITask;
    subject: Subjects;
    expanded: boolean;
    clonesExpanded: boolean;
    clones: TaskCloneStore[];
    loading: boolean;
    taskService: TaskService;

    constructor(data: ITask, subject: Subjects, taskService: TaskService) {
        this.data = data;
        this.expanded = false;
        this.subject = subject;
        this.clonesExpanded = false;
        this.clones = [];
        this.loading = false;
        this.taskService = taskService;
        makeAutoObservable(this);
    }

    toggle() {
        this.expanded = !this.expanded;
    }

    toggleClones() {

        this.clonesExpanded = !this.clonesExpanded;

        if (this.clonesExpanded) {
            
            this.loading = true;

            this.taskService.getPossiblyClones(this.data.id, (data: any) => {
                this.clones = (data['content'] as ITask[]).map(item => new TaskCloneStore(item, this.data.id, this.taskService));
                this.loading = false;
            }, (_) => this.loading = false);
        }
    }
}